"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationDescription = void 0;
const utils_1 = require("../utils");
const OperationDescription = () => {
    return {
        Operation(operation, ctx) {
            utils_1.validateDefinedAndNonEmpty('description', operation, ctx);
        },
    };
};
exports.OperationDescription = OperationDescription;
